import CONFIG from "config/config";

// Post-submission destination (PAD-31990): platform-next home, directly. The legacy platform's own home edge-redirects here, so pointing at legacy (or at its `client-campaigns` list, which isn't even mounted at that path) only flashed the old product for ~2s before landing in the same place.
export function getPostSubmitUrl(): string {
  return `${CONFIG.NEXT_BASE_URL}/dashboard/home`;
}
